import { api } from './api'

export const fetchInvoiceItem = (query) => api.get('/invoice-item', query)
export const fetchTopList = (query) => api.get('/invoice-item/top-missed', query)
export const updateDefectStatus = (defect) => api.put(`/invoice-item/defect/status/${defect.id}`, defect)
